import React from "react";
import logo from "../assets/img/logo.svg";

const NavBar = () => {
  return (
    <nav className="navbar navbar-dark bg-dark py-3 fixed-top">
      <div
        className="navbar-brand d-flex align-items-center"
        style={{ paddingLeft: "2rem" }}
      >
        <img
          src={logo}
          width="30"
          height="30"
          className="d-inline-block align-top"
          alt=""
          style={{ marginRight: "2rem" }}
        />
        <h4> Michael Akindiilete</h4>
      </div>
    </nav>
  );
};

export default NavBar;
